<template>
  <div>
    <md-field>
      <p style="text-align:center; margin-top:40px;">
        <img src="../assets/logo.png" style="width:76px; "/>
        <span style="display:block; font-size:20px;">预约挂号</span>
      </p>
    </md-field>
    <md-field>
      <md-input-item v-model="account" title='用户名' @blur="onBlur" is-highlight></md-input-item>
      <md-input-item v-model="password" type='password' title='密码' @blur="onBlur" is-highlight></md-input-item>
      <md-field-item></md-field-item>
      <md-button type="primary" @click="onSubmitLogin" :loading='loginLoading'>登&nbsp;录</md-button>
    </md-field>
  </div>
</template>

<script>
import { Dialog, Button, Field, FieldItem, InputItem } from 'mand-mobile'
import { login } from '@api/user'
import dayjs from "dayjs"
import cookie from "@utils/store/cookie"
import { LOGIN_BACK_URL } from "@libs/login"

export default {
  name: "Login",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem
  },
  data () {
    return {
      account: '',
      password: '',
      loginLoading: false
    }
  },
  created () {
    if (this.$store.state.token) {
      console.log("from /login redirect to /setting")
      this.$router.replace({
        path: '/setting'
      })
    }
  },
  methods: {
    onBlur() {
      window.scrollTo(0, document.documentElement.scrollTop || document.body.scrollTop)
    },
    onSubmitLogin () {
      console.log('account, password:', this.account, this.password)
      if (!this.account || this.account.length < 2) {
        Dialog.alert({
          title: '错误',
          content: '请填写登录账户'
        })
        return
      }
      if (!this.password || this.password.length < 2) {
        Dialog.alert({
          title: '错误',
          content: '请填写密码'
        })
        return
      }

      this.loginLoading = true
      login({ username: this.account, password: this.password })
        .then(res => {
          this.loginLoading = false
          console.log('login success ...')
          this.$store.commit('LOGIN', res.data.token, dayjs(res.data.expires_time))
          const backUrl = cookie.get(LOGIN_BACK_URL) || '/'
          this.$router.replace({ path: backUrl })
        })
        .catch(err => {
          this.loginLoading = false
          console.log(err)
          Dialog.alert({
            title: '错误',
            content: err.msg
          })
        })
    }
  }
}
</script>

<style scoped>

</style>
